import React, { useEffect, useRef } from 'react';
import { MainContentContainer } from './main-content.styles';
import DashboardRoutes from '../../../../routes/dashboard-routes.component';
import PageTransition from '../../../../components/page-transition/page-transition.component';
import { useLocation } from 'react-router-dom';

const MainContent = () => {
  const location = useLocation();
  const containerRef = useRef(null);
  const isMessagesRoute = location.pathname === '/messages';

  // Scroll to top on route change
  useEffect(() => {
    if (containerRef.current && !isMessagesRoute) {
      containerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location.pathname, isMessagesRoute]);

  return (
    <MainContentContainer
      id="main-content"
      tabIndex={-1}
      ref={containerRef}
      $isMessagesRoute={isMessagesRoute}
    >
      <PageTransition>
        <DashboardRoutes />
      </PageTransition>
    </MainContentContainer>
  );
};

export default MainContent;
